// extracted by mini-css-extract-plugin
module.exports = {"node":"node--LDDGK","minimal":"minimal--2DIXG","alias":"alias--2GhPL"};
    if(module.hot) {
      // 1732531523399
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  